module.exports = __webpack_public_path__ + "img/home5-4.c52dba48.png";